import { ReactElement, useState } from 'react'
import { Button, Image, Text, Textarea } from '../../Atoms'
import Flex from '../Flex'
import { FeedbackProps } from './props'
import { StyledFeedback } from './styles'

const Feedback = ({
    buttonText,
    icon,
    onClickButton,
    placeholder,
    text,
    ...props
}: FeedbackProps): ReactElement => {
    const [textValue, setTextValue] = useState('')

    const isEmpty = textValue.length === 0

    return (
        <StyledFeedback {...props}>
            <Flex gap={8} alignItems="center">
                <Image src={icon} />
                <Text bold primary>
                    {text}
                </Text>
            </Flex>
            <Textarea
                maxRows={10}
                minRows={5}
                onChange={(e) => {
                    setTextValue(e.target.value)
                }}
                placeholder={placeholder}
            />
            <Button disabled={isEmpty} onClick={onClickButton}>
                {buttonText}
            </Button>
        </StyledFeedback>
    )
}

export default Feedback

export { StyledFeedback }
